# there are multiple models that can have jobModels properties this is to ensure
# we have one place that we track all those properties and that they are 
# easily accessible to both properties
getProps = (jobModel) ->
    {
        job_id: jobModel.id(),
        job_name: jobModel.name(),
        job_short_name: jobModel.short_name(),
        job_level: jobModel.level_displays(),
        job_locations: jobModel.location_values(),
        job_categories: jobModel.categories(),
        job_ranking_categories: jobModel.ranking_categories(),
        job_notes_instructions: jobModel.notes_instructions(),
        job_tag_short_names: jobModel.tag_short_names(),
        job_tags: jobModel.tags(),
        job_type: jobModel.type(),
        job_state: jobModel.state(),

        # user props
        job_applied: jobModel.applied(),
        job_favorited: jobModel.favorited(),

        # company props for jobs
        company_id: jobModel.company_id(),
        company_name: jobModel.company_name(),
        company_short_name: jobModel.company_short_name(),

        job_ats_name: jobModel.ats_name()
    }

module.exports = getProps


// WEBPACK FOOTER //
// ./node_modules/musecoreui/models/individual/get_job_props.coffee